import camelCase from 'lodash.camelcase';
import startCase from 'lodash.startcase';
export const toI18nMessageId = (...inputs) => {
    return inputs
        .map(input => startCase(camelCase(input)).replace(/ /g, ''))
        .join('.');
};
//# sourceMappingURL=toI18nMessageId.js.map